module.exports = __webpack_public_path__ + "static/media/Online_Service_JP.a4c2e6c7.png";